import * as Long from 'long';
import { Logger } from '../metrics/logger.js';
import { PushStatus, InfoKeys, PushPartDisableConfigWhiteListKey } from '../consts.js';
import { ContextClassBase } from '../service/RuntimeContext.js';
import * as JSONLong from 'json-long';

/** 会话 Setting Info 结构 */
class ConversationSettingInfo extends ContextClassBase {
    constructor(parent, info) {
        var _a;
        super(parent.ctx);
        /** 会话 Setting 版本 */
        this.version = Long.ZERO;
        /** @internal */
        this.minIndex = Long.ZERO;
        /** @internal */
        this._readIndex = Long.ZERO;
        this.parent = parent;
        if (info !== undefined) {
            this.ext = info.ext;
            this.favor = info.favorite;
            this.mute = info.mute;
            this.stickTop = info.stick_on_top;
            this.version = Long.fromValue((_a = info.setting_version) !== null && _a !== void 0 ? _a : Long.ZERO);
            this.readIndex = info.read_index;
            this.minIndex = info.min_index;
            this.setFavoriteTime = info.set_favorite_time;
            this.setTopTime = info.set_top_time;
            this.pushStatus = info.push_status;
        }
    }
    /**
     * 会话 id
     * {@link Conversation.id}
     */
    get conversationId() {
        return this.parent.id;
    }
    /**
     * 消息推送状态
     * {@link Conversation.pushStatus}
     */
    get pushStatus() {
        return this._pushStatus;
    }
    set pushStatus(value) {
        if ([PushStatus.Allow, PushStatus.PartAllow, PushStatus.Disable].includes(value)) {
            this._pushStatus = value;
        }
        else {
            this._pushStatus = PushStatus.Unknown;
        }
    }
    get readIndex() {
        return this._readIndex;
    }
    set readIndex(val) {
        if (val === undefined) {
            return;
        }
        const realVal = Long.fromValue(val);
        if (this._readIndex === undefined) {
            this._readIndex = realVal;
            return;
        }
        if (realVal.gt(this._readIndex)) {
            this._readIndex = realVal;
        }
    }
    /** 会话 Setting Ext */
    get ext() {
        if (!this.innerExt) {
            this.innerExt = {};
        }
        return this.innerExt;
    }
    /** @internal */
    set ext(val) {
        this.innerExt = val !== null && val !== void 0 ? val : {};
    }
    mergeSetting(newSetting) {
        if (newSetting.version.lt(this.version)) {
            Logger.ctxDebug(this.ctx, 'setting info version local > online, local: ', this.version.toString(), 'new: ', newSetting.version.toString());
            return this;
        }
        if (newSetting.conversationId !== this.conversationId) {
            Logger.ctxDebug(this.ctx, 'setting info conversation not match, local:', this.conversationId.toString(), 'new: ', newSetting.conversationId.toString());
            return this;
        }
        this.stickTop = newSetting.stickTop;
        this.setTopTime = newSetting.setTopTime;
        this.mute = newSetting.mute;
        this.favor = newSetting.favor;
        this.setFavoriteTime = newSetting.setFavoriteTime;
        this.innerExt = Object.assign(Object.assign({}, this.innerExt), newSetting.ext);
        this.readIndex = newSetting.readIndex;
        this.minIndex = newSetting.minIndex;
        this.version = newSetting.version;
        this.pushStatus = newSetting.pushStatus;
        return this;
    }
    get weakMuteInfo() {
        var _a, _b, _c;
        const fallback = { whiteUids: [], whiteMsgTypes: [] };
        if (!this.innerExt[InfoKeys.PushPartDisableConfig]) {
            return fallback;
        }
        try {
            const content = JSONLong.parse(this.innerExt[InfoKeys.PushPartDisableConfig]);
            const whiteList = content === null || content === void 0 ? void 0 : content[PushPartDisableConfigWhiteListKey];
            const whiteUids = (_b = (_a = whiteList === null || whiteList === void 0 ? void 0 : whiteList.white_uids) === null || _a === void 0 ? void 0 : _a.map(Long.fromValue)) !== null && _b !== void 0 ? _b : [];
            const whiteMsgTypes = (_c = whiteList === null || whiteList === void 0 ? void 0 : whiteList.white_msg_types) !== null && _c !== void 0 ? _c : [];
            return {
                whiteUids,
                whiteMsgTypes
            };
        }
        catch (e) {
            Logger.ctxWarn(this.ctx, 'conversation setting weak mute info parse error: ', e);
            return fallback;
        }
    }
}

export { ConversationSettingInfo };
//# sourceMappingURL=ConversationSettingInfo.js.map
